import React, { createContext, useContext } from 'react';

// Context for managing the currently chosen/selected employer and related state
const EmployerContext = createContext();

// Hook to access the chosen employer context (selected employer data, switching logic, etc.)
export const useChosenEmployer = () => {
  const context = useContext(EmployerContext);
  if (!context) {
    throw new Error('useChosenEmployer must be used within an EmployerProvider');
  }
  return context;
};

export const EmployerProvider = ({ children, value }) => {
  return (
    <EmployerContext.Provider value={value}>
      {children}
    </EmployerContext.Provider>
  );
};
